import { useState } from "react";
import { format, parse, isValid } from "date-fns";
import { id } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { cn } from "@/lib/utils";

// Native <input type="date"> renders in the browser locale (often mm/dd/yyyy)
// and can't be forced to dd/mm/yyyy reliably. This picker always shows dd/mm/yyyy
// while storing an ISO (yyyy-MM-dd) string for backend compatibility.
export function DateField({ value, onChange, placeholder = "dd/mm/yyyy", className, testid, hideIcon = false }) {
  const [open, setOpen] = useState(false);
  const parsed = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
  const valid = parsed && isValid(parsed);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={cn(
            "flex h-10 w-full items-center gap-2 rounded-md border border-brand-line bg-white px-3 py-2 text-left text-sm transition focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold",
            !valid && "text-brand-muted",
            className
          )}>
          {!hideIcon && <CalendarIcon className="h-4 w-4 shrink-0 text-brand-muted" />}
          <span className="truncate">{valid ? format(parsed, "dd/MM/yyyy") : placeholder}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          locale={id}
          selected={valid ? parsed : undefined}
          defaultMonth={valid ? parsed : undefined}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
